"use strict";

import $ from "jquery";

export function initInScope($scope) {
    $scope.find('.js-mice-room-area-tabbing').each(function () {
        let $tabs = $(this).find('.js-mice-room-area-tabbing__tab');
        $tabs.on('click', function () {
            let $tab = $(this);
            $tabs.each(function () {
                if (!$(this).is($tab)) {
                    $(this).removeClass('active');
                    $(this).attr('aria-selected', 'false');
                }
            });
        });
    });
}